export const calendarTranslations = {
    buttonText: {
        today: 'Hoje',
        month: 'Mês',
        week: 'Semana',
        day: 'Dia',
        list: 'Lista',
        // prev: 'Prev',
        // next: 'Next',
        prevYear: 'Ano anterior',
        nextYear: 'Ano seguinte',
        year: 'Ano',
    },
    weekText: 'S',
    weekTextLong: 'Semana',
    closeHint: 'Fechar',
    timeHint: 'Tempo',
    eventHint: 'Evento',
    allDayText: 'Dia',
    moreLinkText: 'Mais',
    noEventsText: 'Nenhum evento para mostrar',
}
